(ns client-portal.client.voice-commerce.dashboard.data
  (:require [shared.core.reactive :as re]
            [shared.core.util :as util]
            [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-commerce.orders.data :as orders.d]))

(def root-path [:voice-commerce :dashboard])
(def stats-path (conj root-path :stats))

;; One request, four queries run in parallel server-side, so the cards fill in
;; together rather than racing each other.
(re/reg-auth0-loader
  :voice-commerce/load-dashboard-stats
  stats-path
  (fn [db]
    (when (concepts.d/current-concept-id db)
      {:method :post
       :url "/api/voice-commerce/dashboard-stats"
       :json-params (orders.d/base-query-args db {})}))
  :transf #(some-> % :body (util/->kebab-case-keywords))
  :error-transf (fn [] {}))

(re/reg-auth0-load-sub
  :voice-commerce/dashboard-stats-
  stats-path
  :voice-commerce/load-dashboard-stats)

(re/reg-event-db
  :voice-commerce/reload-dashboard-stats re/middleware
  (fn [db]
    (assoc-in db stats-path nil)))

;; The stats are scoped to the header's concept/location/date range, so a change
;; there invalidates them.
(re/reg-event-fx
  :voice-commerce/dashboard-initialize re/middleware
  (fn [{:keys [db]}]
    (re/dispatch [:voice-commerce/reload-dashboard-stats])
    {:db db
     :forward-events {:register :voice-commerce-dashboard-initialization-listener
                      :events #{:concepts/select :locations/select :locations/clear-selected
                                :core/select-timeframe :core/timeframe-date-range-changed}
                      :dispatch-to [:voice-commerce/reload-dashboard-stats]}}))
